<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="CN ParaOverride-8" id="_idParaDest-7"><span class="CharOverride-1">Quarrels over women are the keynote of the New Guinea primitive world.</span></p>
<p class="BT1stPara ParaOverride-9"><span class="CharOverride-11">—Margaret Mead</span></p>
<p class="BT1stPara ParaOverride-10"><span class="CharOverride-11">Experience, contrary to common belief, is mostly imagination.</span></p>
<p class="BT1stPara ParaOverride-9"><span class="CharOverride-11">—Ruth Benedict</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook42766.vue?764c87c0